import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import TranslationAddContainer from "./TranslationAddContainer";
import TranslationOverviewContainer from "./TranslationOverviewContainer";
import ErrorPageContainer from "../errors/ErrorPageContainer";

class TranslationContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            activeView: null,
        };

        this.translate = this.props.baseData.translate;

        this.changeView = this.changeView.bind(this);

    }

    changeView(activeView = null) {

        this.setState({
            activeView
        });

    }

    renderView() {

        const view = this.state.activeView;

        if (view === 'add') {
            return <TranslationAddContainer
                baseData={this.props.baseData}
                changeView={this.changeView}
            />;
        } else {
            return <TranslationOverviewContainer
                baseData={this.props.baseData}
                changeView={this.changeView}
            />;
        }

    }

    render() {

        if (!this.props.baseData.checkUserRole('translations')) return <ErrorPageContainer baseData={this.props.baseData} code={401} />;

        const renderedView = this.renderView();

        return (
            <div>
                {renderedView}
            </div>
        );

    }

}

export default TranslationContainer;